import { Routes } from "@angular/router";

import { bookRoutes } from "../book-service";
import { exhibitionsAndEventsRoutes } from "../exhibitions-and-events";

import { WARM_OFFLINE } from "src/app/core/offline/route-warm.service";

export const servicesRoutes: Routes = [
  {
    path: "",
    // The grid a clerk lands on, and the one screen the sidebar still offers offline.
    data: { [WARM_OFFLINE]: true },
    loadComponent: () => import("./pages/services/services.component").then((c) => c.ServicesComponent),
  },
  {
    path: "book",
    children: [{ path: "", redirectTo: "/services", pathMatch: "full" }, ...bookRoutes],
  },
  {
    path: "exhibitions-and-events",
    children: exhibitionsAndEventsRoutes,
  },
];
